import { AutocompleteWithLabel, CheckboxWithLabel } from '@adotel/components'
import { FormikErrors, FormikTouched } from 'formik'
import React, { useEffect, useState } from 'react'

import SectionTitle from '../../components/SectionTitle'
import { getCurrenciesAvailable } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { Accommodation } from '../../types/accommodation'

interface AccommodationInventoryAndBookingDetailsProps {
  values: Accommodation
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<Accommodation>
  touched: FormikTouched<Accommodation>
  handleBlur: any
  isSubmitting: any
  classes: any
  loading: boolean
}

export const AccommodationInventoryAndBookingDetails: React.FC<
  AccommodationInventoryAndBookingDetailsProps
> = ({
  values,
  setFieldValue,
  errors,
  touched,
  handleBlur,
  isSubmitting,
  classes,
  loading
}) => {
  const [autoCompleteLabelCurrencies, setautoCompleteLabelCurrencies] =
    useState<any[]>([])

  useEffect(() => {
    const temp: any[] = []
    values?.inventoryAndBooking?.currencies.forEach((value) => {
      temp.push({ label: value?.toString(), value: value?.toString() })
    })
    setautoCompleteLabelCurrencies(temp)
  }, [values?.inventoryAndBooking?.currencies])

  return (
    <>
      <SectionTitle title="Inventory & Booking" marginBottom />
      <div className={classes.fieldsContainer}>
        <AutocompleteWithLabel
          data-cy="inventoryAndBookingCurrencies"
          name="inventoryAndBooking.currencies"
          label={getTranslate('Currencies')}
          placeholder={getTranslate('Select list of supported currencies')}
          value={autoCompleteLabelCurrencies}
          onChange={(event, v: any) => {
            const selectedCurrencies: string[] = []
            v.map((value: any) => selectedCurrencies.push(value.value))
            setFieldValue('inventoryAndBooking.currencies', selectedCurrencies)
          }}
          getOptionLabel={(option) => option?.label || ''}
          getOptionSelected={(option, value) => option.value === value.value}
          options={
            getCurrenciesAvailable().map((item) => ({
              label: item as string,
              value: item as string
            })) || []
          }
          size="small"
          multiple
          includeInputInList
          error={
            (touched.inventoryAndBooking?.currencies &&
              !!errors.inventoryAndBooking?.currencies) ||
            undefined
          }
          helpertext={
            touched.inventoryAndBooking?.currencies &&
            !!errors.inventoryAndBooking?.currencies
              ? getTranslate(
                  (errors.inventoryAndBooking?.currencies as string) || ''
                )
              : undefined
          }
          onBlur={handleBlur}
          disabled={isSubmitting}
          inputSize="small"
          loading={loading}
          loadingText={getTranslate('Loading') + '...'}
        />
        <div className={classes.checkboxContainer}>
          <CheckboxWithLabel
            data-cy="inventoryAndBookingCanReserveCombination"
            name="inventoryAndBooking.canReserveCombination"
            label={getTranslate('Reserve Combination')}
            placeholder={getTranslate(
              'Reserve Combination for this accommodation'
            )}
            value={values?.inventoryAndBooking?.canReserveCombination}
            checked={values?.inventoryAndBooking?.canReserveCombination}
            onChange={(event) =>
              setFieldValue(
                'inventoryAndBooking.canReserveCombination',
                event.currentTarget.checked
              )
            }
            error={
              (touched.inventoryAndBooking?.canReserveCombination &&
                !!errors.inventoryAndBooking?.canReserveCombination) ||
              undefined
            }
            helpertext={
              touched.inventoryAndBooking?.canReserveCombination
                ? getTranslate(
                    errors.inventoryAndBooking?.canReserveCombination || ''
                  )
                : undefined
            }
            onBlur={handleBlur}
            disabled={isSubmitting}
            inputSize="small"
          />
        </div>
      </div>
    </>
  )
}
